<template lang="html">
  <div class="details">
    <div class="detailsContent">
      <div class="oneDetail" v-for="(criteriaGroup, c ) in averageVotesByGroup()" :key="c">
        <div class="value">
            <span class="voteValue">{{ formattedNumber(criteriaGroup.averageVote)}}&nbsp;/&nbsp;5</span>
            <button class="voteButton" type="button" v-if="detailsToogled != criteriaGroup.groupId" @click="toogleDetails(criteriaGroup.groupId)" name="button">
              <span class="voteCriteria">{{ getGroupNameById(criteriaGroup.groupId)}}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99709 11.2004C7.53042 11.2004 7.06375 11.0204 6.71042 10.6671L2.36375 6.32042C2.17042 6.12708 2.17042 5.80708 2.36375 5.61375C2.55708 5.42042 2.87708 5.42042 3.07042 5.61375L7.41708 9.96042C7.73708 10.2804 8.25708 10.2804 8.57709 9.96042L12.9238 5.61375C13.1171 5.42042 13.4371 5.42042 13.6304 5.61375C13.8238 5.80708 13.8238 6.12708 13.6304 6.32042L9.28375 10.6671C8.93042 11.0204 8.46375 11.2004 7.99709 11.2004Z" fill="#3982C4"/>
              </svg>
            </button>
            <button type="button" class="voteButton reverseTheSvg" v-if="detailsToogled == criteriaGroup.groupId" @click="detailsToogled = null" name="button">
              <span class="voteCriteria">{{ getGroupNameById(criteriaGroup.groupId)}}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99709 11.2004C7.53042 11.2004 7.06375 11.0204 6.71042 10.6671L2.36375 6.32042C2.17042 6.12708 2.17042 5.80708 2.36375 5.61375C2.55708 5.42042 2.87708 5.42042 3.07042 5.61375L7.41708 9.96042C7.73708 10.2804 8.25708 10.2804 8.57709 9.96042L12.9238 5.61375C13.1171 5.42042 13.4371 5.42042 13.6304 5.61375C13.8238 5.80708 13.8238 6.12708 13.6304 6.32042L9.28375 10.6671C8.93042 11.0204 8.46375 11.2004 7.99709 11.2004Z" fill="#3982C4"/>
              </svg>
            </button>
        </div>
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: computedProgress(criteriaGroup.averageVote) + '%' }"></div>
        </div>
        <div class="innerDetailsContent">


        <div class="detail5413 small" v-if="detailsToogled ==criteriaGroup.groupId">
          <div class="oneDetail small" v-for="(criteria, c ) in criteriaByGroup(criteriaGroup.groupId)" :key="c">
            <div class="value detailsCriteria" v-if="criteria.details">
              <span class="voteCriteria">{{ criteria.details.name}}
                <small>({{criteria.numberVote}} <span v-if="criteria.numberVote == 1">{{$t("vote")}}</span><span v-else>{{$t('votes')}}</span>)</small>
              </span>

                <span class="voteValue">{{formattedNumber(criteria.averageVote)}}&nbsp;/&nbsp;5</span>

            </div>
            <div class="progress-bar">
              <div class="progress-bar-fill-2" :style="{ width: computedProgress(criteria.averageVote) + '%' }"></div>
            </div>
          </div>
        </div>
                </div>
      </div>

    </div>
  </div>

</template>


<script>
export default {
  name : "VoteResultsDetails",
  data() {
    return {
      detailsToogled : true,
    }
  },
  methods:{
    toogleDetails(gid){
      this.detailsToogled = gid;
    },
    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },
       getGroupNameById(id) {
         console.log("search id:",id);
         console.log(this.criteriaGroups);
         var group = this.criteriaGroups.find(g => g._id.$oid == id);
         console.log("dinf ",group);
         return group ? group.name : null; // Return the groupname or null if not found
       },
       averageVotesByGroup(){
         const groupVotes = {};

        this.vote.criteriaVotes.forEach(item => {
            const groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];
            groups.forEach(group => {
              const groupId = group.$oid;

              // Initialize the group if it doesn't exist
              if (!groupVotes[groupId]) {
                groupVotes[groupId] = {
                  totalVotes: 0,
                  count: 0
                };
              }

              // Accumulate the votes for each group
              groupVotes[groupId].totalVotes += item.averageVote;
              groupVotes[groupId].count += 1;
            });
          });

          // Step 2: Calculate the average for each group
          const averageVotesByGroup = Object.keys(groupVotes).map(groupId => {
            return {
              groupId,
              averageVote: groupVotes[groupId].totalVotes / groupVotes[groupId].count
            };
          });
          return averageVotesByGroup;

       },
       criteriaByGroup(gid) {
         var filteredCriteria = this.vote.criteriaVotes.filter(item => {
         // Check if 'group' is an array or a single object ID
         var groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];

         // Check if any of the groups match the groupId
         return groups.some(group => group.$oid === gid);
       });
       return filteredCriteria.filter(item => item.averageVote != null);
       }
  },
  computed: {
   // Filter the array passed via props
   knownVote() {
     console.log("cv",this.vote.criteriaVotes);
     return this.vote.criteriaVotes.filter(item => item.averageVote != null);
   }
 },
  props: ["vote","criteriaGroups"]
}
</script>

<style media="screen" scoped>

.details{
  position: absolute;
  background: #FFF;
  color: #000;
  bottom: 0;
  left: 20px;
  right:20px;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  min-width:300px;
  padding:20px;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);

}

.details .detailsContent{
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
  width:100%;
}

.value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
}

.progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

.oneDetail{
  width:100%;
}

.oneDetail.small .value{
  display:flex;
  justify-content:  space-between;
  gap:10px;

}
.oneDetail.small .voteValue{
  font-weight: 100;
  font-size:20px;
  color:#0A2071;
  line-height: 25px;
}
.oneDetail.small .voteCriteria{
  color:#0A2071;
  font-size:14px;
  font-weight: 400;
}

.oneDetail.small .progress-bar {
  margin-top: 5px;
  width: 100%;
  height: 4px;
  background-color: #d3eaff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}
.progress-bar-fill-2 {
  height: 100%;
  background-color: #125AA4; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

.detail5413.small{
  margin-top:10px;
  display: flex;
  flex-direction: column;
  gap:10px;
}

.reverseTheSvg svg{
  transform:rotate(-180deg);
}

.voteCriteria small{
  font-weight: 200;
  font-size:12px;
}

.voteButton{
  display:flex;
  gap:5px;
  align-items:center;
  cursor:pointer;
}
.innerDetailsContent{
  margin-top:10px;
}
</style>
